import { ReactNode } from "react";
import { Theme, XStack, YStack } from "tamagui";

import { CloseButton, Logo } from "@/components";

type Variant = "subclinical" | "clinical";

type SidebarChromeProps = {
  children: ReactNode;
  onClose?: () => void;
  variant?: Variant;
  dataTrackingIdPrefix?: string;
};

/** Used for standalone sidebar components that need the standard header and close button */
const SidebarChrome = ({
  children,
  onClose,
  variant = "subclinical",
  dataTrackingIdPrefix,
}: SidebarChromeProps) => {
  const isClinical = variant === "clinical";

  return (
    <Theme name={isClinical ? "clinic" : undefined}>
      <YStack flex={1} borderRadius="$150" backgroundColor="$fillModal">
        <YStack paddingTop="$300" paddingHorizontal="$200">
          <XStack
            alignItems="center"
            justifyContent="space-between"
            position="relative"
            height="$400"
          >
            <XStack flex={1} />
            <XStack
              position="absolute"
              left={0}
              right={0}
              alignItems="center"
              justifyContent="center"
              pointerEvents="none"
            >
              {isClinical ? (
                <Logo.MedicalGroup
                  height="$200"
                  $md={{ height: "$250" }}
                  $lg={{ height: "$300" }}
                  color="$textPrimary"
                />
              ) : (
                <Logo height="$250" $lg={{ height: "$275" }} />
              )}
            </XStack>
            <XStack alignItems="center" justifyContent="center">
              {onClose && (
                <CloseButton
                  onClose={onClose}
                  dataTrackingId={
                    dataTrackingIdPrefix
                      ? `${dataTrackingIdPrefix}-close-button`
                      : undefined
                  }
                />
              )}
            </XStack>
          </XStack>
        </YStack>
        {children}
      </YStack>
    </Theme>
  );
};

export default SidebarChrome;
